import React from 'react';

export default function PrivacyPageUk() {
  return (
    <div style={{
      maxWidth: 900,
      margin: '0 auto',
      padding: '40px 20px',
      lineHeight: 1.6,
      color: '#1b1b1f'
    }}>
      <h1 style={{ marginBottom: 24, color: '#006b44' }}>Політика конфіденційності Radiomonitor.net</h1>
      <p>
        Ця Політика конфіденційності описує, які дані збирає Radiomonitor.net, як вони використовуються та як ми захищаємо вашу
        інформацію. Використовуючи наш Сервіс, ви погоджуєтеся з цією Політикою.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>1. Які дані ми збираємо</h2>
      <p>Ми збираємо лише ті дані, які необхідні для роботи Сервісу:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>технічну інформацію (IP-адреса, тип пристрою, браузер, операційна система);</li>
        <li>статистичні дані щодо підключень слухачів до онлайн-радіостанцій;</li>
        <li>контактні дані, які ви надаєте під час реєстрації (наприклад, e-mail).</li>
      </ul>
      <p>
        Ми не збираємо чутливі персональні дані (наприклад, паспортні чи банківські дані), окрім випадків, коли користувач сам
        надає їх для оплати чи комунікації.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>2. Як ми використовуємо дані</h2>
      <p>Дані використовуються виключно для:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>надання послуг аналітики та моніторингу ефіру;</li>
        <li>покращення роботи Сервісу;</li>
        <li>технічної підтримки користувачів;</li>
        <li>інформування про оновлення та нові можливості Radiomonitor.net.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>3. Передача даних третім особам</h2>
      <p>Ми не продаємо і не передаємо ваші дані третім особам.</p>
      <p>Виняток становлять випадки, коли передача необхідна за вимогою закону.</p>
      <p>
        Для обробки платежів ми можемо використовувати надійні сторонні платіжні системи (вони обробляють дані незалежно від нас).
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>4. Збереження даних</h2>
      <p>Ми зберігаємо дані лише стільки, скільки потрібно для надання послуг.</p>
      <p>Користувач може звернутися із запитом на видалення своїх даних, і ми виконаємо це протягом розумного терміну.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>5. Захист даних</h2>
      <p>
        Radiomonitor.net застосовує технічні та організаційні заходи для захисту даних від несанкціонованого доступу, зміни чи
        знищення.
      </p>
      <p>
        Ми не можемо гарантувати 100% безпеки в мережі Інтернет, але робимо все можливе для її забезпечення.
      </p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>6. Файли cookie</h2>
      <p>Ми можемо використовувати cookie для зручності роботи користувачів і збору статистики.</p>
      <p>Ви можете вимкнути cookie у своєму браузері, але це може вплинути на коректність роботи Сервісу.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>7. Ваші права</h2>
      <p>Користувач має право:</p>
      <ul style={{ paddingLeft: 20 }}>
        <li>отримати інформацію про свої дані, які зберігає Сервіс;</li>
        <li>вимагати їх виправлення чи видалення;</li>
        <li>відкликати згоду на обробку даних.</li>
      </ul>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>8. Зміни до Політики</h2>
      <p>Ми можемо періодично оновлювати цю Політику. Актуальна версія завжди доступна на сайті Radiomonitor.net.</p>

      <h2 style={{ marginTop: 32, marginBottom: 16 }}>9. Контакти</h2>
      <p>
        З питань конфіденційності звертайтесь:
        <br />
        support@radiomonitor.net
      </p>
    </div>
  );
}
